"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoWrapperStyled = exports.VideoWrapperMobStyled = exports.ModalHeaderStyled = exports.ModalStyled = exports.ImageWrap = exports.ColStyled = exports.RowStyled = exports.Container = exports.Content = exports.CardText = exports.Headline2 = exports.Headline1 = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _modal = require("@dbi-tools/ui-kit/lib/modal");

var _video = require("../video/video.styled");

var _styled = require("../../styled");

var _helpers = require("../../helpers");

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  ", " {\n    padding-top: 56.33%;\n\n    & > div {\n      position: absolute;\n      left: 0;\n      top: 0;\n      right: 0;\n      overflow: hidden;\n    }\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  & > ", " {\n    position: inherit;\n  }\n  ", " {\n    position: relative;\n    padding-top: 66.66%;\n\n    & > ", " {\n      position: absolute;\n      left: 0;\n      top: 0;\n      right: 0;\n    }\n  }\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  display: flex;\n  font-size: 24px;\n  line-height: 36px;\n  max-width: none;\n  padding: 22px 30px;\n  position: relative;\n  justify-content: space-between;\n\n  p {\n    margin: 0;\n  }\n\n  button {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  min-height: 100%;\n  padding-top: ", "%;\n  position: relative;\n  width: 100%;\n  z-index: 1;\n  img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  margin: auto;\n\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      text-align: ", ";\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n              padding: 30px 138px 30px 60px;\n            "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n              left: -87px;\n              padding: 30px 60px 30px 138px;\n            "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      padding-bottom: ", ";\n\n      ", " {\n        position: relative;\n        top: 50px;\n        width: calc(100% + 87px);\n\n        ", "\n\n        ", " {\n          left: 0;\n          padding: 60px;\n          top: 0;\n          width: 100%;\n        }\n\n        ", " {\n          padding: 30px;\n        }\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    padding: 60px 177px;\n    padding-bottom: ", ";\n    padding-top: ", ";\n\n    ", " {\n      ", "\n    }\n\n    ", " {\n      padding-left: 112px;\n      padding-right: 112px;\n    }\n\n    ", " {\n      padding: 30px 24px;\n      padding-bottom: ", ";\n      padding-top: ", ";\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  padding: 63px 60px;\n  min-height: 100%;\n  justify-content: center;\n\n  ", " {\n    height: auto;\n    min-height: 0;\n    padding: 60px;\n  }\n\n  ", " {\n    padding: 30px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  p {\n    margin-top: 15px;\n    margin-bottom: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  margin-bottom: -12px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Headline1 = (0, _uiKit.styled)("h2")(_templateObject(), _styled.Line1Styles);
exports.Headline1 = Headline1;
var Headline2 = (0, _uiKit.styled)("h3")(_templateObject2(), _styled.Line2Styles);
exports.Headline2 = Headline2;
var CardText = (0, _uiKit.styled)("div")(_templateObject3(), _styled.Line3Styles);
exports.CardText = CardText;
var Content = (0, _uiKit.styled)(_uiKit.Box)(_templateObject4(), _uiKit.Colors.white, _uiKit.GridBreakpointsMediaDown.xl, _uiKit.GridBreakpointsMediaDown.sm);
exports.Content = Content;
var Container = (0, _uiKit.styled)(_uiKit.Box)(_templateObject5(), function (_ref) {
  var removeTopPadding = _ref.removeTopPadding,
      removeBottomPadding = _ref.removeBottomPadding,
      isOffsetLayout = _ref.isOffsetLayout;
  return (0, _uiKit.css)(_templateObject6(), removeBottomPadding ? 0 : '60px', removeTopPadding ? 0 : '60px', _uiKit.GridBreakpointsMediaUp.xl, removeBottomPadding ? "padding-bottom: ".concat(isOffsetLayout ? '50px' : '0', ";") : "", _uiKit.GridBreakpointsMediaDown.xl, _uiKit.GridBreakpointsMediaDown.sm, removeBottomPadding ? 0 : '30px', removeTopPadding ? 0 : '30px');
}, function (_ref2) {
  var $theme = _ref2.theme.$theme;
  return (0, _helpers.getTheme)($theme);
}, function (_ref3) {
  var _ref3$theme = _ref3.theme,
      $layoutType = _ref3$theme.$layoutType,
      $layoutArrangement = _ref3$theme.$layoutArrangement,
      removeBottomPadding = _ref3.removeBottomPadding;
  return $layoutType === 'offset' && (0, _uiKit.css)(_templateObject7(), removeBottomPadding ? '0' : '110px', Content, $layoutArrangement === 'img_left' ? (0, _uiKit.css)(_templateObject8()) : (0, _uiKit.css)(_templateObject9()), _uiKit.GridBreakpointsMediaDown.xl, _uiKit.GridBreakpointsMediaDown.sm);
}, function (_ref4) {
  var $textAlign = _ref4.theme.$textAlign;
  return $textAlign && (0, _uiKit.css)(_templateObject10(), $textAlign);
});
exports.Container = Container;
var RowStyled = (0, _uiKit.styled)(_uiKit.Row)(_templateObject11(), function (_ref5) {
  var $layoutArrangement = _ref5.theme.$layoutArrangement;
  return $layoutArrangement === 'img_right' && "\n    flex-direction: row-reverse;\n  ";
});
exports.RowStyled = RowStyled;
var ColStyled = (0, _uiKit.styled)(_uiKit.Col)(_templateObject12());
exports.ColStyled = ColStyled;
var ImageWrap = (0, _uiKit.styled)("div")(_templateObject13(), 100 / 3 * 2);
exports.ImageWrap = ImageWrap;
var ModalStyled = (0, _uiKit.styled)(_modal.Modal)(_templateObject14());
exports.ModalStyled = ModalStyled;
var ModalHeaderStyled = (0, _uiKit.styled)(_modal.Modal.Header)(_templateObject15(), _uiKit.Colors.secondaryLight);
exports.ModalHeaderStyled = ModalHeaderStyled;
var VideoWrapperMobStyled = (0, _uiKit.styled)("div")(_templateObject16(), _video.VideoWrapper, _uiKit.GridBreakpointsMediaDown.xl, _video.VideoWrapper);
exports.VideoWrapperMobStyled = VideoWrapperMobStyled;
var VideoWrapperStyled = (0, _uiKit.styled)("div")(_templateObject17(), _uiKit.GridBreakpointsMediaDown.xl);
exports.VideoWrapperStyled = VideoWrapperStyled;